import { render, staticRenderFns } from "./ScratchPad.vue?vue&type=template&id=4ac2a463&"
import script from "./ScratchPad.vue?vue&type=script&lang=ts&"
export * from "./ScratchPad.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports